import LoadingText from '@/components/LoadingText/LoadingText';
export default LoadingText;
